import React from 'react';

import RelatorioPersonalizado from '../relatorioPersonalizado';
import ContentWrapper from '../lib_react_adminlte/componentes/ContentWrapper.jsx';
import Button from '../lib_react_adminlte/componentes/Button.jsx';
import InputMask from '../lib_react_adminlte/componentes/InputMask.jsx';
import { RadioGroup, RadioButton } from '../lib_react_adminlte/componentes/RadioGroup.jsx';
import { inverteData } from '../utils/funcoesGenericas';
import ApiceComboEditPanel from '../lib_react_adminlte/componentes/ApiceComboEditPanel.jsx'
import { getColunasEspecialidade } from '../lib_react_adminlte/common/Template.jsx';
import Api from '../utils/Api.jsx';

/**
 */
export default class RelatorioMovimental extends React.Component {

  state = {
    registro: {
      tabela: 'AGENDA',
      dt_inicio: '',
      dt_fim: '',
      especialidade: '',
    },
  };
  /**
   * Chamado quando algum campo mudar seu valor no formulário.
   * @param {string} prop O Campo que mudou o valor
   * @param {any} value O Valor que será colocado no campo.
   */
  onChange(prop, value) {
    this.setState({
      registro: {
        ...this.state.registro,
        [prop]: value.target ? value.target.value : value,
      },
    });
  }

  emitirRelatorio() {
    if (!this.state.registro.tabela) { return false; }
  
    const relatorio = new RelatorioPersonalizado();
  
    if (this.state.registro.tabela === 'AGENDA') {
      let whereClause = '';
      if (this.state.registro.dt_inicio && this.state.registro.dt_fim) {
        const inicio = inverteData(this.state.registro.dt_inicio);
        const fim = inverteData(this.state.registro.dt_fim);
        whereClause = `WHERE c.dt_cadastro BETWEEN "${inicio}" AND "${fim}"`;
      }
  
      if (this.state.registro.especialidade) {
        if (whereClause) {
          whereClause += ' AND ';
        } else {
          whereClause = 'WHERE ';
        }
        whereClause += `b.especialidade = "${this.state.registro.especialidade}"`;
      }
  
      relatorio.titulo = 'Pagamento dos Médicos';
      relatorio.sql = 'SELECT a.cod_compra AS "Cod", b.nome_medico AS "Médico", e.especialidade AS "Especialidade", ' +
        'FORMAT(a.vr_total_item, 2, 4) AS "Valor total", ' +
        'DATE_FORMAT(c.dt_cadastro, "%d/%m/%Y") AS "Dia", ' +
        'DATE_FORMAT(c.dt_entrada, "%H:%i") AS "HR. Entrada", ' +
        'DATE_FORMAT(c.dt_saida, "%H:%i") AS "HR. Saida" ' +
        'FROM tab_compra_item a ' +
        'INNER JOIN tab_produto b ON a.cod_medico = b.cod_medico ' +
        'INNER JOIN tab_compra c ON a.cod_compra = c.cod_compra ' +
        'INNER JOIN tab_especialidade e ON b.med_especialidade = e.cod_especialidade';
      
        whereClause;
  
      relatorio.larguras = [30, '*', '*', '*', '*', '*', '*'];
    }
  
    relatorio.gerar();
  }
  

  renderForm() {
    return (
      <div>

        <div className="row">    
          <div className="row col-sm-12">

            <div className="col-sm-12">
              <RadioGroup title="Tipos"
                          className="mt-10">

                <div className="row">
                  <div className="col-sm-4 col-xs-3">
                    <RadioButton name="tabela"
                                 text="Gerar relatório"
                                 checked={this.state.registro.tabela === 'AGENDA'}
                                 onChange={() => this.setState({ registro: { tabela: 'AGENDA' } })} />
                  </div>
                </div>
                
              </RadioGroup>
            </div>

            <div className="col-sm-3">  
              <InputMask label="Dt. início:"
                         dataHora
                         value={this.state.registro.dt_inicio}
                         onChange={this.onChange.bind(this, 'dt_inicio')} />
            </div>

            <div className="col-sm-3">  
              <InputMask label="Dt. Fim:"
                         dataHora
                         value={this.state.registro.dt_fim}
                         onChange={this.onChange.bind(this, 'dt_fim')} />
            </div>
            
            <div className="col-sm-4">
                  <ApiceComboEditPanel label="Especialidade:"
                    tabela="tab_especialidade"
                    chave="cod_especialidade"
                    desc="especialidade"
                    colunas={getColunasEspecialidade()}
                    value={this.state.registro.especialidade}
                    onChange={e => this.onChange('especialidade', e.target.value)}
                    ref={e => this.comboEditPanelEspecialidade = e}
                    api={Api} 
                    />
            </div>


          </div>
        </div> 
        <br /><br />

        <div className="row">    
          <div className="row col-sm-12">

            <div>
              <Button className="mt-5 ml-5 btn-success"
              label="Gerar Relatório"
              onClick={this.emitirRelatorio.bind(this)}
              icon="fa-check" />
            </div>

          </div>
        </div> 

      </div>
    );
  }

  render() {
    return (
      <div className="h-100">
        <ContentWrapper title="Relatório Movimental"
                        small="Exiba seus Relatórios de Movimento" >
          {this.renderForm()}
        </ContentWrapper>
      </div>
    );
  }
  
}




// WEBPACK FOOTER //
// ./src/componentes/RelatorioMovimental.jsx